import type { Ref } from 'vue';

import { ref } from 'vue';

// TODO
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dialog
// https://html.spec.whatwg.org/multipage/interactive-elements.html#the-dialog-element

export interface DialogComposable {
  isDialog: Ref<boolean>;
  openDialog: () => void;
  closeDialog: () => void;
}

export default function useDialog(): DialogComposable {
  const isDialog = ref(false);

  function openDialog(): void {
    isDialog.value = true;
  }

  function closeDialog(): void {
    isDialog.value = false;
  }

  return {
    isDialog,
    openDialog,
    closeDialog,
  };
}
